<template>
    <label :for="id" class="c-form_label" :class="{'-required': required}">
        {{ labelText }}
    </label>
    <textarea class="c-form_textarea" :id="id" :name="name" :placeholder="placeholder" :required="required">
        {{ modelValue }}
    </textarea>
    <div class="c-form_validation">
        <div class="c-form_validation_required">
            {{ _t("Enter a value for this field.") }}
        </div>
        <div class="c-form_validation_invalid">
            {{ _t("This field is invalid.") }}
        </div>
    </div>
</template>
<script>
export default {
    name: 'TextareaInput',
    props: {
        id: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        },
        labelText: {
            type: String,
            default: ''
        },
        modelValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    }
}
</script>